import { useCallback } from "react";
import { Colors } from "../../utils/colors";
import StandardBorderedContainer from "../Containers/StandardBorderedContainer";
import { Icon } from "@iconify/react";
import RectangleButton from "../Buttons/RectangleButton";
import { AutomationItemPreview } from "../DisplayItem/CampaignItem/AutomationItemPreview";
import { CampaignDetails } from "../../redux/slices/campaignSlice";
import { Campaign, Event } from "@markit/common.types";
import ShowclixLogo from "../../assets/ShowclixLogo.png";

type ShowclixEventPanelProps = {
  event: Event;
  campaign: Campaign | undefined;
  campaignDetail: CampaignDetails | undefined;
};

export const ShowclixEventPanel = (props: ShowclixEventPanelProps) => {
  const { event, campaign, campaignDetail } = props;

  const styles = {
    optionsContainer: {
      backgroundColor: Colors.WHITE,
      padding: 24,
    },
  };

  const visitShowclix = useCallback(() => {
    window.open(`https://admin.showclix.com/event/${event.externalEventId}`);
  }, [event]);

  return (
    <div className="ColumnNormal" style={{ gap: 30 }}>
      {campaign && campaignDetail ? (
        <StandardBorderedContainer
          containerStyles={{
            backgroundColor: Colors.WHITE,
            padding: 14,
            borderRadius: 14,
            flex: 1,
          }}
        >
          <AutomationItemPreview
            campaignItem={campaign}
            campaignDetail={campaignDetail}
            onEventDashboard
          />
        </StandardBorderedContainer>
      ) : null}
      <StandardBorderedContainer containerStyles={styles.optionsContainer}>
        <div className="AlignedRowSpaced">
          <div className="ColumnNormal" style={{ gap: 24 }}>
            <div className="ColumnNormal" style={{ gap: 14 }}>
              <span style={{ fontWeight: 500, fontSize: 20 }}>
                Synced Showclix Event
              </span>
              <span className="bodySubtext">
                This is a synced event. Manage your event on Showclix.
              </span>
            </div>
            <div>
              <RectangleButton
                buttonLabel="Visit Showclix"
                onPress={visitShowclix}
                altPaddingHorz={24}
                altPaddingVert={14}
                altBorderRadius={12}
                iconRight={
                  <Icon
                    icon="ion:arrow-forward"
                    height={15}
                    style={{
                      color: Colors.WHITE,
                      transform: "rotateY(0deg) rotate(-45deg)",
                    }}
                  />
                }
                altColor={Colors.BLACK}
                altTextColor={Colors.WHITE}
                width={170}
              />
            </div>
          </div>
          <img
            alt="ShowclixLogo"
            src={ShowclixLogo}
            width={175}
            height={175}
            style={{ marginRight: -14 }}
          />
        </div>
      </StandardBorderedContainer>
    </div>
  );
};
